module.exports = __webpack_public_path__ + "media/video.167a9c02.mp4";